import { createRequest, composeRequestConfig } from '../core/utils/axios/api';
import { teamsEnv } from '../core/utils';
export var getAssignmentTemplates = function getAssignmentTemplates(query) {
  var queryString = new URLSearchParams(query).toString();
  var url = "/api/v1/assignment_templates?".concat(queryString);
  var config = composeRequestConfig({
    url: url
  });
  return createRequest(config);
};
export var createAssignmentTemplate = function createAssignmentTemplate(query) {
  var queryString = new URLSearchParams(query).toString();
  var url = "/api/v1/assignment_templates?".concat(queryString);
  var config = composeRequestConfig({
    url: url,
    method: 'post'
  });
  return createRequest(config);
};
export var updateAssignmentTemplateFeedback = function updateAssignmentTemplateFeedback(id, payload) {
  var url = "/api/v1/assignment_templates/".concat(id, "/update_feedback");
  var config = composeRequestConfig({
    url: url,
    method: 'post',
    payload: payload
  });
  return createRequest(config);
};
export var showAssignmentTemplate = function showAssignmentTemplate(id) {
  var url = "/api/v1/assignment_templates/".concat(id);
  var config = composeRequestConfig({
    url: url
  });
  return createRequest(config);
};
export var updateAssignmentTemplate = function updateAssignmentTemplate(id, payload) {
  var url = "/api/v1/assignment_templates/".concat(id);
  var config = composeRequestConfig({
    url: url,
    payload: payload,
    method: 'patch'
  });
  return createRequest(config);
};
export var deleteAssignmentTemplate = function deleteAssignmentTemplate(id) {
  var url = "/api/v1/assignment_templates/".concat(id);
  var config = composeRequestConfig({
    url: url,
    method: 'delete'
  });
  return createRequest(config);
};
export var createAssignmentFromAssignmentTemplate = function createAssignmentFromAssignmentTemplate(id) {
  var payload = {
    channel_id: teamsEnv.channelId,
    assignment_type: 'ms_teams'
  };
  var url = "/api/v1/assignment_templates/".concat(id, "/use_template");
  var config = composeRequestConfig({
    url: url,
    method: 'post',
    payload: payload
  });
  return createRequest(config);
};